import React, { useEffect, useState } from "react";
import style from "./DeEmpanelHospital.module.css";
import CommonButton from "../CommonButton";
import SearchIcon from "@mui/icons-material/Search";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { useCallback } from "react";
import TableComponent from "../Table";
import { invoiceTableData } from "../../constants/sampleData";
import { pageLimit } from "../../Utils/helper";
import CommonInput from "../CommonInput";
import CommonDescription from "../CommonDescription";
import { useSelector } from "react-redux";
import useToaster from "../../customHook/useToaster";
import {
  getHospitalList,
  postBlacklistCases,
} from "../../Services/de-empanel.service";
import { submitFinal } from "../../Services/caseManagement.service";

//Here id is an index on invoiceTableData
const deEmpanelMapping = {
  "De-Empanel Hospital": {
    id: 0,
    name: "Hospital",
    type: "hospital",
    dataKey: "data",
    totalCountKey: "TotalCount",
    nameSearch: "hsname",
    codeSearch: "hospitalCode",
    panSearch: "pan",
    stateSearch: "state",
    citySearch: "city",
    pincodeSearch: "pincode",
  },
  "Negative Garage": {
    id: 1,
    name: "Garage",
    type: "garage",
    dataKey: "result",
    totalCountKey: "count",
    nameSearch: "garage_name",
    codeSearch: "garage_code",
    panSearch: "pan",
    stateSearch: "state",
    citySearch: "city",
    pincodeSearch: "pincode",
  },
};

const DeEmpanelHospital = ({
  type = "De-Empanel Hospital",
  // onClick = () => {},
  submitFinalApiCall = () => {},
  // setShowDeEmpanelHospital = () => {},
}) => {
  const [selectedIds, setselectedIds] = useState([]);
  const [remark, setRemark] = useState("");
  const caseId = useSelector((state) => state?.CaseDescriptionSlice?.caseId);
  const [hospitalData, setHospitalData] = useState([]);
  const [reRender, setReRender] = useState(false);
  const [hospitalSearchObj, setHospitalSearchObj] = useState({});
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const rowsPerPage = pageLimit;
  const { showToast } = useToaster();
  const activeDeEmpanel = deEmpanelMapping[type];

  const searchItems = [
    {
      label: `${activeDeEmpanel?.name} Name`,
      objId: activeDeEmpanel?.nameSearch,
    },
    {
      label: `${activeDeEmpanel?.name} Code`,
      objId: activeDeEmpanel?.codeSearch,
    },
    { label: "PAN", objId: activeDeEmpanel?.panSearch },
    { label: "State", objId: activeDeEmpanel?.stateSearch },
    { label: "City", objId: activeDeEmpanel?.citySearch },
    { label: "Pin Code", objId: activeDeEmpanel?.pincodeSearch },
  ];

  const firstButtonClicked = useCallback(() => {
    setPage(1);
  }, []);

  const lastButtonClicked = useCallback(() => {
    setPage(Math.ceil(count / rowsPerPage));
  }, [rowsPerPage, count]);

  const handleNextButtonClick = useCallback(() => {
    setPage((page) => page + 1);
  }, []);

  const handleBackButtonClick = useCallback(() => {
    setPage((page) => page - 1);
  }, []);

  const onPageDropdownChange = useCallback((e) => {
    setPage(Number(e.target.value));
  }, []);

  const SearchTabClicked = (e, id) => {
    setHospitalSearchObj((prev) => {
      let newSearchObj = {
        ...prev,
        [id]: e.target.value,
      };
      if (!e.target.value) delete newSearchObj[id];
      return newSearchObj;
    });
  };

  const SearchButtonClicked = (e) => {
    setPage(1);
    setReRender((prev) => !prev);
  };

  const handleCheckboxClick = (e) => {
    if (e?.target?.checked) {
      setselectedIds((prev) => {
        let newIds = [...prev, Number(e?.target?.id)];
        return newIds;
      });
    } else {
      setselectedIds((prev) => {
        let newIds = [...prev?.filter((id) => id != e?.target?.id)];
        return newIds;
      });
    }
  };

  const SubmitButtonClicked = async (e) => {
    try {
      if (!selectedIds?.length)
        return showToast(
          `Please Select ${activeDeEmpanel?.name}.`,
          "warning",
          true
        );
      if (!remark) return showToast("Please provide remark", "warning", true);
      let payload = {
        ids: selectedIds,
        caseId,
        remark,
      };
      submitFinalApiCall(postBlacklistCases, [activeDeEmpanel?.type, payload]);
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Error in fetching list",
        "error",
        true
      );
    }
  };

  const getHospitalListFun = async () => {
    try {
      const offset = (page - 1) * pageLimit;
      let searchQuery = "";
      Object.keys(hospitalSearchObj).forEach((item) => {
        searchQuery = searchQuery + item + "=" + hospitalSearchObj[item] + "&";
      });
      searchQuery = searchQuery + `offset=${offset}`;
      const data = await getHospitalList(activeDeEmpanel?.type, searchQuery);
      if (data?.success) {
        let responseDataList =
          data?.[activeDeEmpanel?.dataKey] ||
          data?.data?.[activeDeEmpanel?.dataKey];
        let caseManagementData = responseDataList?.map((item, i, arr) => {
          arr[i] = {
            ...arr[i],
            srNo: offset + i + 1,
            select: (
              <input
                style={{ accentColor: "#E42125", cursor: "pointer" }}
                id={item[`${activeDeEmpanel?.type}_id`]}
                type="checkbox"
                onChange={handleCheckboxClick}
              />
            ),
          };
          return arr[i];
        });

        setHospitalData(caseManagementData);
        setCount(
          data?.[activeDeEmpanel?.totalCountKey] ||
            data?.data?.[activeDeEmpanel?.totalCountKey]
        );
      } else {
        setHospitalData([]);
        setCount(0);
        showToast(data?.message || "Error in fetching list", "error", true);
      }
    } catch (error) {
      setHospitalData([]);
      setCount(0);
      showToast(
        error?.response?.data?.message || "Error in fetching list",
        "error",
        true
      );
    }
  };
  useEffect(() => {
    getHospitalListFun();
  }, [page, reRender]);

  return (
    <div className={style["main-container"]}>
      <Typography sx={{ mb: "1.3rem", fontSize: "1.4rem", color: "#7C7C7C" }}>
        Search By
      </Typography>
      <div className={style["main-container-search"]}>
        <div className={style["search-tab-main-container"]}>
          {searchItems?.map((item, index) => {
            return (
              <CommonInput
                placeholder={item?.label}
                removeBackGround
                outlineStyle={{ height: "4.6rem" }}
                onChange={(e) => SearchTabClicked(e, item?.objId)}
              />
            );
          })}
        </div>
        <div className={style["search-button"]}>
          <CommonButton
            onClick={SearchButtonClicked}
            width="100%"
            label="Search"
            filledButton
            isIcon
            fontSize="1.9rem"
            rightAlign
            iconName={<SearchIcon sx={{ fontSize: "2.4rem" }} />}
          ></CommonButton>
        </div>
      </div>
      <Box sx={{ position: "relative" }}>
        {/* <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            borderRadius: "10px",
          }}
        >
          <h2 style={{ fontSize: "2rem", color: "#FFFFFF" }}>Coming Soon</h2>
        </div> */}
        <TableComponent
          page={page}
          rowsPerPage={rowsPerPage}
          count={count}
          firstButtonClicked={firstButtonClicked}
          lastButtonClicked={lastButtonClicked}
          handleNextButtonClick={handleNextButtonClick}
          handleBackButtonClick={handleBackButtonClick}
          onPageDropdownChange={onPageDropdownChange}
          setPage={setPage}
          columnHeaderBackgroundColor={"#FCF7FF"}
          columnHeaderColor={"#242424"}
          columnHeaderFont="1.1rem"
          columnHeaderFontWeight={600}
          columnBodyFont="1.01rem"
          columnBodyFontWeight={400}
          rowsData={hospitalData}
          columnsData={invoiceTableData[activeDeEmpanel?.id].column}
          alternnateStyledRowColor={"#FBF5FF"}
          alternnateStyledRow={true}
          hideBorders={true}
        ></TableComponent>

        <CommonDescription
          heading="Remark"
          placeholder="Enter Remark"
          onChange={(e) => setRemark(e?.target?.value)}
          onSubmitButton={SubmitButtonClicked}
          descriptionVal={remark}
        />
      </Box>
    </div>
  );
};

export default DeEmpanelHospital;
